var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organisations-wrapper full-width subpage-wrapper-small"},[_c('sekretariat',{staticClass:"mb-2 subpage-content"}),_c('kantonskirchenrat',{staticClass:"subpage-content"}),_c('kirchen-vostand',{staticClass:"full-width mt-2"}),_c('rekurskommission',{staticClass:"subpage-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }